import { render, staticRenderFns } from "./title2.vue?vue&type=template&id=ff2cfeae"
import script from "./title2.vue?vue&type=script&lang=js"
export * from "./title2.vue?vue&type=script&lang=js"
import style0 from "./title2.vue?vue&type=style&index=0&id=ff2cfeae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports